import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { RadioGroup, Radio, Grid, TextField, Paper } from '@material-ui/core';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';
import FormLabel from '@material-ui/core/FormLabel';

const RefuseEmail = ({ data, setResponseMessage }) => {
const needAnswer = {
    Nao: false,
    Sim: true,
};
  const { setMessageData } = useMessageBox();
  const [isLoading, setIsLoading] = useState(false);
  const [motive, setMotive] = useState(0)
  const [other, setOther] = useState('')
  const [showTextfield, setShowTextfield] = useState(false);
  const [minLength, setMinLength] = useState(0);

  const handleChange = (event) => {
    setOther('')
    setMotive(Number(event.target.value));
    const foundData = data.motivosRecusas.find(
      (el) => el.motivoRecusaId === Number(event.target.value),
    );
    if(foundData) {
        setShowTextfield(needAnswer[foundData.solicitaResposta]);
        setMinLength(foundData.quantidadeMinimaDigitos);
    }
  };

  const submitForm = async () => {
    const formData = {
        ancoraId: data.ancoraId,
        conclusao: data.conclusao,
        dataAtualizacao: data.dataAtualizacao,
        emailInteresseAutenticacaoId: data.emailInteresseAutenticacaoId,
        emailInteresseId: data.emailInteresseId,
        emailInteresseMotivoRecusaId: motive,
        fornecedorId: data.fornecedorId,
        respostaDoFornecedor: other
    }
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesEmailsInteresses/ConcluirEmailInteresse', formData);
      setMessageData(response.data?.complemento?.mensagensBox);
      if (response.data.resposta.sucesso) {
        toast.success('Recusa Enviada!');
        setResponseMessage(response.data.resposta.mensagem);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  return (
      <div>
            <S.InfoContainer>
                <S.TableTitleHeader>
                    <h1>Não Tenho Interesse na Proposta</h1>
                </S.TableTitleHeader>
                <div style={{ padding: '5px 10px' }}>
                    <div
                        className="message-html"
                        dangerouslySetInnerHTML={{
                            __html: data.mensagem,
                        }}
                    />
                </div>
            </S.InfoContainer>
            <S.InfoContainer>
                <div style={{ padding: '0px 10px' }}>
                    <S.ConfirmationBox>
                        <>
                            <span>Motivo recusa:</span>
                            <RadioGroup
                                value={motive}
                                onChange={handleChange}
                                style={{ display: 'flex' }}
                            >
                                {data.motivosRecusas.map((motivo) => (
                                    <div>
                                        <Radio
                                            checked={motive === motivo.motivoRecusaId}
                                            validaBotaoTeclado
                                            value={motivo.motivoRecusaId}
                                            name="radio-buttons"
                                            inputProps={{ 'aria-label': 'B' }}
                                        />
                                        <span>{motivo.motivoRecusa}</span>
                                    </div>
                                ))}
                            </RadioGroup>
                            {showTextfield ? (
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <S.InputLabel>
                                            Informe o motivo da sua recusa no campo abaixo:
                                        </S.InputLabel>
                                        <Paper elevation={0} className="select-paper" style={{ border: '1px solid #000000' }}>
                                            <TextField
                                                multiline
                                                rows={5}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    maxLength: data?.mensagemDigitosMaximo,
                                                    minLength: minLength
                                                }}
                                                value={other}
                                                onChange={(e) => setOther(e.target.value)}
                                                helperText={`${
                                                    Number(data?.mensagemDigitosMaximo) - other.trim().length
                                                } caracteres restantes`}
                                            />
                                        </Paper>
                                        {other.trim().length < minLength && (
                                            <S.ErrorMessage>
                                                Quantidade mínima de caracteres: {minLength}
                                            </S.ErrorMessage>
                                        )}
                                    </Grid>
                                </Grid>
                            ) : (
                                <></>
                            )}
                        </>
                        {data.botaoEnviar && (
                            <S.ActionButton
                                variant="contained"
                                disabled={
                                    !motive ||
                                    (showTextfield && other.trim().length < minLength)
                                    || isLoading
                                }
                                onClick={() => submitForm()}
                            >
                                {isLoading ? 'Enviando...' : 'Enviar'}
                            </S.ActionButton>
                        )}
                    </S.ConfirmationBox>
                </div>
            </S.InfoContainer>
      </div>
    )
};

export default RefuseEmail;
